<template>
  <div class="identity-backdrop">
    <div class="identity-card">
      <div class="identity-card__brand">
        <div class="auto-auction-logo" aria-label="AutoAuction.com">
          <span class="auto-auction-logo__auto">Auto</span><span class="auto-auction-logo__auction">Auction</span><span class="auto-auction-logo__top-level-domain">.com</span>
        </div>
      </div>
      <div class="identity-card__actions">
        <h1 class="identity-card__title">
          {{ linked ? t('authentication.linking.linkedTitle') : t('authentication.linking.linkRefusedTitle') }}
        </h1>
        <p class="identity-card__lede link-outcome__verdict">{{ lede }}</p>
        <button class="button button--primary link-outcome__primary" type="button" @click="backToSignInSecurity">
          {{ t('authentication.linking.linkOutcomeBackButton') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import '../shared/identity-card.css';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { IDENTITY_PATHS } from '@hds/identity-client-sdk';

defineOptions({ name: 'LinkOutcomePage' });

// The acknowledgement a link round trip ("Add a login", or the parked connect
// from the not-linked choice screen) lands on. The person just came back from
// a trip off the app, so the verdict is a page in the identity card — what
// happened, in plain words, and one way back to Sign-in & security — never a
// toast (identity effort ruling 2026-09-21). The boot flow's
// routeForBootOutcome writes the query this page reads: `outcome=linked`, or
// `outcome=refused` with the server's `reason`.

const route = useRoute();
const router = useRouter();
const { t } = useI18n();

const linked = computed(() => route.query.outcome === 'linked');

const lede = computed(() => {
  if (linked.value) return t('authentication.linking.linkedLede');
  const reason = String(route.query.reason ?? '');
  // The one refusal a person can act on gets its own sentence: the login
  // already belongs to another account.
  if (reason === 'CONNECTION_IN_USE') return t('authentication.linking.connectionInUse');
  return t('authentication.linking.linkRefusedLede', { reason: reason || t('authentication.linking.errorGeneric') });
});

// Replace, not push: back from Sign-in & security must not return to a verdict
// that has already been read.
function backToSignInSecurity() {
  router.replace(IDENTITY_PATHS.signInSecurity);
}
</script>

<style scoped>
/* The shared card skin lives in ../shared/identity-card.css. */
</style>
